<template>
  <div
    v-if="isOpen"
    class="fixed inset-0 z-50 flex items-center justify-center"
  >
    <div class="fixed inset-0 bg-gray-500 opacity-75" @click="close"></div>
    <div
      class="bg-white rounded-lg overflow-hidden shadow-xl transform transition-all sm:max-w-lg sm:w-full"
    >
      <div class="px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
        <div class="">
          <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
            <h3 class="text-lg leading-6 font-medium text-gray-900">
              Add Saved Reply
            </h3>
            <div class="mt-4">
              <label
                for="replyName"
                class="block text-sm font-medium leading-5 text-gray-700"
              >
                Name
              </label>
              <div class="mt-1 relative rounded-md shadow-sm">
                <input
                  id="replyName"
                  v-model="replyName"
                  placeholder="Enter reply name"
                  class="bg-white focus:outline-none focus:shadow-outline border border-gray-300 rounded-md py-2 px-4 block w-full appearance-none leading-normal"
                />
              </div>
            </div>
            <div class="mt-4">
              <label
                for="replyContent"
                class="block text-sm font-medium leading-5 text-gray-700"
              >
                Content
              </label>
              <div class="mt-1 relative rounded-md shadow-sm">
                <textarea
                  id="replyContent"
                  v-model="replyContent"
                  placeholder="Enter reply content"
                  class="bg-white focus:outline-none focus:shadow-outline border border-gray-300 rounded-md py-2 px-4 block w-full appearance-none leading-normal"
                  style="min-height: 120px;"
                ></textarea>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
        <button
          type="button"
          class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:ml-3 sm:w-auto sm:text-sm"
          @click="saveReply"
        >
          Save
        </button>
        <button
          type="button"
          class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:w-auto sm:text-sm"
          @click="close"
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: {
    isOpen: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      replyName: "",
      replyContent: ""
    };
  },
  methods: {
    ...mapActions("Inbox", ["createSavedReply"]),
    close() {
      this.$emit("close");
      this.replyName = "";
      this.replyContent = "";
    },
    saveReply() {
      if (this.replyName.trim() && this.replyContent.trim()) {
        const newReply = {
          name: this.replyName,
          content: this.replyContent
        };
        this.createSavedReply(newReply).then(() => {
          this.$emit("save", newReply);
          this.close();
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
